import { TextBox } from "./text-box";

/**
 * Form Control for Select-like input
 *
 * Generic base control for anything that walks and talks like a select input.
 *
 * @todo Add validators
 */
export class SelectBox extends TextBox {
    public static SELECTOR_INPUT: string = "select";

    constructor(containerElement: Element) {
        super(containerElement, containerElement.querySelector(SelectBox.SELECTOR_INPUT));
    }
}



// WEBPACK FOOTER //
// ../common/material/form/select-box.ts